module.exports = __webpack_public_path__ + "static/media/oberflex-chenevieillit312-2560x1440.008c3bd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-chenevieillit312-2560x1440.jpg
// module id = 999
// module chunks = 37